import React from 'react';
import StatusPage from './pages/status'

function App() {
  return (
    <div className="App">
      <StatusPage />
    </div>
  );
}

export default App;
